{
  "_meta": {
    "pricingVersion": "litellm-2026-05-snapshot",
    "source": "https://github.com/BerriAI/litellm/blob/main/model_prices_and_context_window.json",
    "fetchedAt": "2026-05-27",
    "note": "Hand-curated snapshot of top models 2026; refresh via scripts/refresh-pricing.mjs. Per-million-tokens USD."
  },
  "models": {
    "anthropic/claude-opus-4-7": {
      "input": 5.0,
      "output": 25.0,
      "cacheRead": 0.5,
      "cacheWrite": 6.25
    },
    "anthropic/claude-opus-4-6": {
      "input": 5.0,
      "output": 25.0,
      "cacheRead": 0.5,
      "cacheWrite": 6.25
    },
    "anthropic/claude-opus-4-5": {
      "input": 5.0,
      "output": 25.0,
      "cacheRead": 0.5,
      "cacheWrite": 6.25
    },
    "anthropic/claude-sonnet-4-6": {
      "input": 3.0,
      "output": 15.0,
      "cacheRead": 0.3,
      "cacheWrite": 3.75
    },
    "anthropic/claude-sonnet-4-5": {
      "input": 3.0,
      "output": 15.0,
      "cacheRead": 0.3,
      "cacheWrite": 3.75
    },
    "anthropic/claude-haiku-4-5": {
      "input": 1.0,
      "output": 5.0,
      "cacheRead": 0.1,
      "cacheWrite": 1.25
    },
    "anthropic/claude-3-5-sonnet": {
      "input": 3.0,
      "output": 15.0,
      "cacheRead": 0.3,
      "cacheWrite": 3.75
    },
    "anthropic/claude-3-5-haiku": {
      "input": 0.8,
      "output": 4.0,
      "cacheRead": 0.08,
      "cacheWrite": 1.0
    },
    "anthropic/claude-3-opus": {
      "input": 15.0,
      "output": 75.0,
      "cacheRead": 1.5,
      "cacheWrite": 18.75
    },
    "anthropic/claude-3-haiku": {
      "input": 0.25,
      "output": 1.25,
      "cacheRead": 0.03,
      "cacheWrite": 0.3
    },
    "openai/gpt-4o": {
      "input": 2.5,
      "output": 10.0,
      "cacheRead": 1.25
    },
    "openai/gpt-4o-mini": {
      "input": 0.15,
      "output": 0.6,
      "cacheRead": 0.075
    },
    "openai/gpt-4.1": {
      "input": 2.0,
      "output": 8.0,
      "cacheRead": 0.5
    },
    "openai/gpt-4.1-mini": {
      "input": 0.4,
      "output": 1.6,
      "cacheRead": 0.1
    },
    "openai/gpt-4.1-nano": {
      "input": 0.1,
      "output": 0.4,
      "cacheRead": 0.025
    },
    "openai/o3": {
      "input": 10.0,
      "output": 40.0,
      "cacheRead": 2.5
    },
    "openai/o3-mini": {
      "input": 1.1,
      "output": 4.4,
      "cacheRead": 0.55
    },
    "openai/o4-mini": {
      "input": 1.1,
      "output": 4.4,
      "cacheRead": 0.275
    },
    "deepseek/deepseek-chat": {
      "input": 0.14,
      "output": 0.28
    },
    "deepseek/deepseek-reasoner": {
      "input": 0.55,
      "output": 2.19
    },
    "google/gemini-2.5-pro": {
      "input": 1.25,
      "output": 10.0
    },
    "google/gemini-2.5-flash": {
      "input": 0.15,
      "output": 0.6
    },
    "google/gemini-2.0-flash": {
      "input": 0.1,
      "output": 0.4
    }
  }
}
